import { Plus } from "lucide-react";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

import { AddInvitationForm } from "./add-invitation.form";

type AddInvitationModalProps = {
  organisationId?: string;
};

export function AddInvitationModal({
  organisationId,
}: AddInvitationModalProps) {
  const [isCreateInvitationModalOpen, setIsCreateInvitationModalOpen] =
    useState(false);

  return (
    <Dialog
      open={isCreateInvitationModalOpen}
      onOpenChange={setIsCreateInvitationModalOpen}
    >
      <div>
        <DialogTrigger asChild>
          <Button>
            <Plus className="mr-2 size-4" /> Add Users
          </Button>
        </DialogTrigger>
      </div>
      <DialogContent className="max-w-xl">
        <DialogHeader>
          <DialogTitle>Invite User</DialogTitle>
          <DialogDescription>
            Enter details required to invite a new user
          </DialogDescription>
        </DialogHeader>
        <AddInvitationForm
          onClose={() => setIsCreateInvitationModalOpen(false)}
          organisationId={organisationId}
        />
      </DialogContent>
    </Dialog>
  );
}
